import React from 'react';
import { colors } from './colors';
import NotRunning from 'icons/indexed-icons/NotRunning';
import Wrench from 'icons/indexed-icons/Wrench';
import Offline from 'icons/indexed-icons/Offline';
import CheckCircle from 'icons/indexed-icons/CheckCircle';
import Cleaning2 from 'icons/indexed-icons/Cleaning2';
import Sterilization from 'icons/indexed-icons/Sterilization';
import { MachineUhtIcon } from 'icons/indexed-icons/machineUhtIcon';
import { CipIcon } from 'icons/indexed-icons/CipIcon';
import { RinseIcon } from 'icons/indexed-icons/RinseIcon';

export const Icons: Record<string, JSX.Element> = {
  idle: <NotRunning color={colors?.['idle']}/>,
  maintenance: <Wrench color={colors?.['maintenance']}/>,
  cleaning: <Cleaning2 color={colors?.['cleaning']}/>,
  sterilization: <Sterilization color={colors?.['sterilization']}/>,
  'sterilisation': <Sterilization color={colors?.['sterilization']}/>,
  'wait time': <Offline color={colors?.['wait time']}/>,
  'waittime': <Offline color={colors?.['wait time']}/>,
  production: <CheckCircle color={colors?.['production']}/>,
  standby: <NotRunning color={colors?.['idle']}/>,
  machine: <MachineUhtIcon/>,
  "intermediate cip": <CipIcon/>,
  "main cip": <CipIcon color={colors?.['cleaning']}/>,
  "rinse": <RinseIcon/>,
};